/**
 * @returns {React.ReactElement}
 */
const ContentHubAudio = () => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 31 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_818_3003)">
      <path
        d="M15.3206 40.8524C6.87109 40.8524 -0.00390625 33.9539 -0.00390625 25.4714C-0.00390625 24.9379 0.428113 24.5076 0.960762 24.5076C1.49341 24.5076 1.92543 24.9379 1.92543 25.4714C1.92543 32.8877 7.93379 38.9239 15.3206 38.9239C22.7074 38.9239 28.7722 32.8877 28.7722 25.4714C28.7722 24.9379 29.2042 24.5076 29.7369 24.5076C30.2695 24.5076 30.7015 24.9379 30.7015 25.4714C30.7015 33.9539 23.8014 40.8524 15.3198 40.8524H15.3206Z"
        fill="#6B6B6B"
      />
      <path
        d="M15.3175 35.5163C9.80967 35.5163 5.32812 31.0113 5.32812 25.4714V10.5449C5.32812 5.005 9.80967 0.5 15.3175 0.5C20.8253 0.5 25.3641 5.005 25.3641 10.5449V25.4722C25.3641 31.0113 20.8574 35.5172 15.3175 35.5172V35.5163ZM15.3175 2.42848C10.8732 2.42848 7.25746 6.06944 7.25746 10.5449V25.4722C7.25746 29.9477 10.8732 33.5887 15.3175 33.5887C19.7617 33.5887 23.4339 29.9477 23.4339 25.4722V10.5449C23.4339 6.06944 19.7929 2.42848 15.3175 2.42848Z"
        fill="#6B6B6B"
      />
      <path
        d="M15.3201 50.5C14.7875 50.5 14.3555 50.0697 14.3555 49.5362V39.8886C14.3555 39.3551 14.7875 38.9248 15.3201 38.9248C15.8528 38.9248 16.2848 39.3551 16.2848 39.8886V49.5362C16.2848 50.0697 15.8528 50.5 15.3201 50.5Z"
        fill="#6B6B6B"
      />
      <path
        d="M20.0867 50.5001H10.6092C10.0766 50.5001 9.64453 50.0698 9.64453 49.5363C9.64453 49.0028 10.0766 48.5725 10.6092 48.5725H20.0867C20.6194 48.5725 21.0514 49.0028 21.0514 49.5363C21.0514 50.0698 20.6194 50.5001 20.0867 50.5001Z"
        fill="#6B6B6B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1016 10.5001C11.1016 10.003 11.5045 9.6001 12.0016 9.6001H19.0016C19.4986 9.6001 19.9016 10.003 19.9016 10.5001C19.9016 10.9972 19.4986 11.4001 19.0016 11.4001H12.0016C11.5045 11.4001 11.1016 10.9972 11.1016 10.5001Z"
        fill="#6B6B6B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1016 14.5001C11.1016 14.003 11.5045 13.6001 12.0016 13.6001H19.0016C19.4986 13.6001 19.9016 14.003 19.9016 14.5001C19.9016 14.9972 19.4986 15.4001 19.0016 15.4001H12.0016C11.5045 15.4001 11.1016 14.9972 11.1016 14.5001Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_818_3003">
        <rect
          width="30.7063"
          height="50"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ContentHubAudio;
